import request from "@/utils/request";
// 获取更换微信二维码
export function GetChangeWxQrcode(params) {
  return request({
    url: "/h5/setting/getChangeWxQrcode",
    method: "post",
    params,
  });
}